import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "../../admin.service";

@Component({
    selector: 'app-add-quote',
    templateUrl: './add-quote.component.html',
    styleUrls: ['./add-quote.component.scss']
  })
  
export class ProcureAddQuoteComponent implements OnInit {

    public quoteForm: FormGroup;
    public moment: any;
    public loginName: string;
    public loginUserId: string;
    public addresses: any;

    constructor(
        private fb: FormBuilder, 
        public adminService: AdminService, 
        private toastr: ToastrService,
        public router: Router
    ){

    }

    ngOnInit(): void {
        this.moment = moment;
        this.loginName = localStorage.getItem('name');
        this.loginUserId = localStorage.getItem('id');
        this.getProfileDetails();
        this.getQuoteForm();
    }

    public getQuoteForm(): void{
        this.quoteForm = this.fb.group({
            'deliverydate': [null],
            'customerid': [this.loginUserId],
            'shippingaddressid': [null],
            'supplierid': [0],
            "quantity": [0],
            "totalcost": [0],
            "taxes": [0],
            "shipingcost": [10],
            "paymentmethodid": [0],
            "paymentstatusid": [0],
            "currencytypeid": [1],
            "contactperson": ["10"],
            "shipmenttermsid": [41],
            "paymenttermsid": [42],
            "loanid": [0],
            "insertype": ["23"],
            "salesrepid": [0],
            'items': this.fb.array([])
        });
        
        this.addItemsArray();
    }

    public addItemsArray(){
        (this.quoteForm.get('items') as FormArray).push(this.fb.group({
            "id": [null],
            "materialtypeid": [null],
            "mategrialdescription": [null],
            "quantity": [null],
            "targetdate": [null],
            "itemcost": [null],
            "priceperkg": [null]
          }));
    }

    public removeItems(idx): void{
        (this.quoteForm.get('items') as FormArray).removeAt(idx);
    }

    getProfileDetails() {
        this.adminService.getUserProfileDetails().subscribe(
          (res: any) => {
            this.addresses = res.addresses;
          },
          err => {
             console.log(err);
          }
        );
    }

    saveQuote(){
        const quoteRequest = this.quoteForm.getRawValue();
        quoteRequest.customerid = Number(quoteRequest.customerid);
        quoteRequest.shippingaddressid = Number(quoteRequest.shippingaddressid);
        quoteRequest.supplierid = Number(quoteRequest.supplierid);
        let totalQuantity = 0;
        this.quoteForm.getRawValue().items.forEach((element, i) => {
            totalQuantity += element.quantity;
            quoteRequest.items[i]['itemcost'] = element.quantity * element.priceperkg;
        });
        quoteRequest.quantity = totalQuantity;
        this.adminService.createQuotes(quoteRequest).subscribe(
            (res: any) => {
                if(res?.status == 'success'){
                    this.backQuotePage();
                    this.toastr.success('Successfully created quotes');
                } else {
                    this.toastr.error('Something went wrong');
                }
            },
            err => {
               console.log(err);
            }
          );
    }

    backQuotePage(){
      this.router.navigate(['/admin/procure']);
    }

    updateCost(){
        var items = this.quoteForm.getRawValue().items;
        items.forEach((element, i) => {
            element.quantity = element.quantity ?? 0;
            element.priceperkg = element.priceperkg ?? 0;
            console.log(element.quantity)
            console.log(element.priceperkg)
            console.log(this.quoteForm.getRawValue().items[i]['quantity']);
            this.quoteForm.getRawValue().items[i]['itemcost'] = element.quantity * element.priceperkg;
            // element.itemcost = element.quantity * element.priceperkg;
        });
    }

}